module.exports = __webpack_public_path__ + "static/media/mobileProduct2.e6193815.svg";